import { createSelector } from '@reduxjs/toolkit';
import { selectAccessSystem } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Свободный', value: false },
  { label: 'По пропускам', value: true },
];

export const selectAccessSystemFilter = createSelector(selectAccessSystem, value => ({
  label: 'Пропускной режим',
  options: OPTIONS,
  value: [value ?? null],
}));
